"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _variables = _interopRequireDefault(require("@/styles/variables.scss"));
var setCss = function setCss(record) {
  record.td && (record.td.style.background = _variables.default.editTableCol);
};
var _default = exports.default = setCss;